"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentSchema = exports.SlotSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const utterance_type_1 = require("../type/utterance.type");
const data_1 = require("@citibot/data");
const MessageSchema = yup_lib_1.default.object().shape({
    contentType: yup_lib_1.default.string().required().label('Content Type'),
    content: yup_lib_1.default.string().required().label('Content')
});
const ContentSchema = yup_lib_1.default.object().shape({
    messages: yup_lib_1.default.array().of(MessageSchema).required().label('Messages'),
    maxAttempts: yup_lib_1.default.number().label('Maximum Attempts')
});
exports.SlotSchema = yup_lib_1.default.object().shape({
    slotConstraint: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(data_1.SlotConstraintOptionEnum))
        .required()
        .label('Slot Constraint'),
    priority: yup_lib_1.default.number().required().label('Priority'),
    name: yup_lib_1.default.string().required().label('Name'),
    maxAttempts: yup_lib_1.default.number().required().label('Maximum Attempts'),
    ellicitedMessage: yup_lib_1.default.string().label('Ellicited Message'),
    obfuscationSetting: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(data_1.ObfuscationSettingsOptionEnum))
        .label('Obfuscation Setting'),
    slotType: yup_lib_1.default.string().required().label('Slot Type')
});
exports.IntentSchema = yup_lib_1.default.object().shape({
    name: yup_lib_1.default.string().required().label('Name'),
    description: yup_lib_1.default.string().label('Description'),
    utterances: yup_lib_1.default.array().of(utterance_type_1.utteranceSchema).optional(),
    slots: yup_lib_1.default.array().of(exports.SlotSchema).optional(),
    confirmationPrompt: ContentSchema.optional().label('Confirmation Prompt'),
    rejectionStatement: ContentSchema.optional().label('Rejection Statement'),
    conclusionStatement: ContentSchema.optional().label('Conclusion Statement'),
    parentIntentSignature: yup_lib_1.default.string(),
    isSRIntent: yup_lib_1.default.boolean().optional().label('Is SR Intent'),
    acceptedBots: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).required().label('Accepted Bots')
});
